import React from "react";

const CropShort = () => <div />;
export default CropShort;
